const T_PREFIX = "blog-item";

export const tableOfContentTrns = {
  title: `${T_PREFIX}.table-of-content.title`,
};
